var translation = {
	Navatar: {
		header: "ملف التعريف في AWS",
		subheader: "يساعد ملفك التعريفي على تحسين تفاعلاتك مع تجارب AWS المحددة.",
		profileButtonText: "عرض ملف التعريف",
		logOutText: "تسجيل الخروج",
		logInText: "تسجيل الدخول",
		createProfileText: "إنشاء ملف تعريفي",
		federateLoginModalTitle: "استخدم Midway للوصول إلى ملف تعريف AWS",
		federateLoginModalFirstDescription: "بصفتك موظفًا في Amazon، نوصي باستخدام Midway للوصول إلى ملف تعريف AWS. توفر هذه الطريقة الموصى بها أمنيًا تكاملاً سلسًا مع أنظمتك الداخلية.",
		federateLoginModalSecondDescription: "تظهر لك هذه الرسالة لأنك قمت بتسجيل الدخول باستخدام عنوان بريد إلكتروني من Amazon باستخدام باني AWS ID. سيظهر هذا الأمر في كل مرة تسجل فيها الدخول حتى تقوم بالتبديل إلى Midway، أو تختار المتابعة باستخدام طريقة تسجيل الدخول الحالية.",
		federateLoginModalPrimaryButton: "تسجيل الدخول باستخدام Midway",
		federateLoginModalSecondaryButton: "المتابعة باستخدام باني AWS ID"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
